
import { Component, Prop, Vue } from 'vue-property-decorator'
import TicketSpyy from '@/views/Ticket/indexSpyy.vue'

@Component({
  name: 'AllMyCreatedOrderLists',
  components: {
    TicketSpyy
  }
})
export default class extends Vue {}
